module.exports = __webpack_public_path__ + "static/intellisense-css-2545c4026093176d39bf5784142db7aa.webp";